import z from 'zod';
import { CommentDto } from './comment.dto';
import type { InteractionBaseDto } from './interactions/interaction-base.dto';
import { ResourceInteractionDto } from './resourcing.dto';

export type NoteDto = {
  id: number;
  userId: string;
  feedItemId: number;
  savedOnce: boolean;
  text: string;
  delta: any;
  draftText: string;
  draftDelta: any;
  shouldSync: boolean;
  syncOperations: any[];
  readOnly: boolean;
  comments: CommentDto[];
  resourceInteraction: ResourceInteractionDto;
  createdBy: string;
  createdAt?: number;
  updatedAt?: number;
  deletedAt?: number;
} & InteractionBaseDto<'note'>;

export interface CreateNoteRequestDto {
  userId?: string;
  feedItemId?: number;
  text?: string;
  resourceTitle?: string;
  userNeedId?: number;
}

export interface UpdateNoteRequestDto {
  noteId: number;
  text: string;
  delta?: any;
}

export interface AutoSaveNoteDto {
  subjectId: string;
  createdBy: string;
  type: string;
  text: string;
}

export interface UpdateAutoSaveNoteDto {
  text: string;
}

export const CreateNoteFormSchema = z.object({
  text: z
    .string()
    .refine(data => data.replace(/<[^>]*>/g, '').trim().length > 0, {
      message: 'Required',
    }),
  userId: z.string(),
});

export type CreateNoteForm = z.infer<typeof CreateNoteFormSchema>;

export const UpdateNoteFormSchema = z.object({
  text: z
    .string()
    .refine(data => data.replace(/<[^>]*>/g, '').trim().length > 0, {
      message: 'Required',
    }),
  noteId: z.number().optional(),
});

export type UpdateNoteForm = z.infer<typeof UpdateNoteFormSchema>;
